<script setup lang="ts">
import type { Subject } from "~/types/subject"

definePageMeta({
  name: "variant",
  layout: "variant",
})

const store = useProductContentStore()

const route = useRoute<"variant">()

function getChaptersInFolder(id: number) {
  return store.subjects
    .filter(i => i.parentLocationId === id)
    .sort(byPriority)
}

const chaptersNotInFolders = computed(() => {
  const chapters: Subject[] = []
  store.subjects.forEach((i) => {
    if (store.folders.every(j => j.id !== i.parentLocationId)) {
      chapters.push(i)
    }
  })

  return chapters.sort(byPriority)
})

function restoreHashScroll() {
  if (!location.hash)
    return

  document.getElementById(
    location.hash.substring(1),
  )?.scrollIntoView()
}

// This watcher follows the v-if condition of the <ul>
watch(
  () => store.subjects.length || store.folders.length,
  () => {
    // A timeout is needed as the elements are not yet in DOM, not even after nextTick().
    setTimeout(() => restoreHashScroll(), 500)
  },
)

onMounted(() => {
  restoreHashScroll()
})
</script>

<template>
  <div>
    <ul
      v-if="store.subjects.length || store.folders.length"
      id="chapter-cards"
      :key="0"
    >
      <li class="mb-11">
        <UContinue v-if="!route.hash" />
      </li>
      <li
        v-for="(folder, key) in store.folders"
        :id="`chapter-card-list-item-${folder.id}`"
        :key="key"
      >
        <UFolderCard
          :chapters="getChaptersInFolder(folder.id)"
          :folder="folder"
        />
      </li>
      <li
        v-for="(chapter, key) in chaptersNotInFolders"
        :id="`chapter-card-list-item-${chapter.id}`"
        :key="key"
      >
        <UChapterCard :chapter="chapter" class="mb-10 lg:mb-14" />
      </li>
    </ul>

    <USkeletonCardList v-else :key="1" />
  </div>
</template>
